export interface Story {
  _id: string;
  id: string;
  title: string;
  content: string;
  summary?: string;
  coverImageUrl?: string;
  ageRange: AgeRange;
  storyType: StoryType;
  characters: Character[];
  createdBy: string;
  createdAt: Date;
  tags?: string[];
  isPublic: boolean;
  likes: number;
  readCount: number;
  liked: boolean;
  imageUrls?: string[];
}

export enum AgeRange {
  TODDLER = "2-4",
  PRESCHOOL = "4-6",
  SCHOOL_AGE = "6-9",
  PRETEEN = "9-12"
}

export enum StoryType {
  ADVENTURE = "adventure",
  FANTASY = "fantasy",
  EDUCATIONAL = "educational",
  BEDTIME = "bedtime",
  MORAL = "moral",
  FUNNY = "funny",
  SCARY = "scary",
  SCIENCE_FICTION = "science_fiction",
  HISTORICAL = "historical",
  ANIMAL = "animal"
}

export interface Character {
  id: string;
  name: string;
  type: CharacterType;
  traits: string[];
  description?: string;
}

export enum CharacterType {
  HUMAN = "human",
  ANIMAL = "animal",
  MAGICAL = "magical",
  ROBOT = "robot",
  ALIEN = "alien",
  MYTHICAL = "mythical",
  OBJECT = "object"
}
